import { ContainerModule } from 'inversify';
import {
  IncludeComponentsService,
  IncludeComponentsServiceSymbol
} from './include-components-service';

export const includeComponentsModule = new ContainerModule((bind) => {
  bind<IncludeComponentsService>(IncludeComponentsServiceSymbol).to(IncludeComponentsService);
});
